const collapseScript =
  document.currentScript ||
  document.querySelector('script[src*="coveo-facet-collapse.js"]');

document.addEventListener("DOMContentLoaded", () => {
  (async function initFacetCollapser() {
    const container = document.querySelector("atomic-commerce-facets");
    const userInteractedFacets = new WeakSet();
    const processedFacets = new WeakSet();
    if (!container) return;

    const wireFacetInteractions = () => {
      container.addEventListener(
        "click",
        (event) => {
          const path = event.composedPath();

          const clickedControl = path.find((node) => {
            return (
              node instanceof HTMLElement &&
              (node.getAttribute?.("part") === "show-more" ||
                node.getAttribute?.("part") === "show-less")
            );
          });

          if (!clickedControl) return;

          const facet = path.find(
            (node) =>
              node?.tagName?.toLowerCase?.() === "atomic-commerce-facet",
          );

          if (facet) {
            userInteractedFacets.add(facet);

            // Remove flag shortly after render settles.
            setTimeout(() => {
              userInteractedFacets.delete(facet);
            }, 500);
          }
        },
        true,
      );
    };

    const configuredCollapseAfter = Number(
      collapseScript?.dataset?.collapseAfter ?? 2,
    );
    const collapseAfter = Number.isFinite(configuredCollapseAfter)
      ? Math.max(0, Math.floor(configuredCollapseAfter))
      : 2;

    const applyCollapsePolicy = () => {
      const facets = Array.from(container.children).filter(
        (node) => node.tagName?.toLowerCase() === "atomic-commerce-facet",
      );

      facets.forEach((facet, index) => {
        // Apply the initial policy only once per facet.
        // After that, the user owns the expand/collapse state.
        if (processedFacets.has(facet)) return;
        processedFacets.add(facet);

        // Keep the configured number of leading facets expanded.
        if (index < collapseAfter) {
          facet.removeAttribute("is-collapsed");
          return;
        }

        // Presence of the clear button indicates an active facet selection.
        const clearButton = facet.shadowRoot?.querySelector('[part="clear-button"]');
        const hasActiveSelection = !!clearButton;

        if (hasActiveSelection) {
          facet.removeAttribute("is-collapsed");
        } else {
          facet.setAttribute("is-collapsed", "true");
        }
      });
    };

    const scheduleCollapsePolicy = () => {
      // Best-effort timing guard: two animation frames plus a zero-delay timeout
      // usually lets Atomic finish render and shadow DOM updates before we
      // inspect facet state. This reduces race conditions but is not a hard guarantee.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(applyCollapsePolicy, 0);
        });
      });
    };

    const wireSearchSubscription = async () => {
      const interfaceEl = document.querySelector("atomic-commerce-interface");
      if (!interfaceEl) return;

      try {
        const [
          { initializeBindings },
          { buildSearch: buildCommerceSearch, buildProductListing },
        ] = await Promise.all([
          import("https://static.cloud.coveo.com/atomic/v3/index.esm.js"),
          import("https://static.cloud.coveo.com/shopify/v1/headless.esm.js"),
        ]);

        const bindings = await initializeBindings(interfaceEl);
        const interfaceType = interfaceEl.getAttribute("type");
        const controllerBuilder =
          interfaceType === "product-listing"
            ? buildProductListing
            : buildCommerceSearch;
        const controller = controllerBuilder(bindings.engine);
        const summary = controller.summary();

        summary.subscribe(() => {
          const { firstRequestExecuted, isLoading, hasError } = summary.state;

          // Run collapse after successful search states.
          const searchCompleted = firstRequestExecuted && !isLoading && !hasError;

          if (searchCompleted) {
            scheduleCollapsePolicy();
          }
        });
      } catch (error) {
        console.error("[Facet Collapser] Initialization failed:", error);
      }
    };
    wireFacetInteractions();
    await wireSearchSubscription();
    scheduleCollapsePolicy();
  })();
});